import { BlueprintInstanceType } from '../blueprint-classes';
import { ComponentInstanceType } from '../component-classes';
import { NoteInstanceType } from '../note-classes';

export * from './size.type';

export const InstanceTypes = { ...BlueprintInstanceType, ...ComponentInstanceType, ...NoteInstanceType };
export type InstanceTypes = BlueprintInstanceType | ComponentInstanceType | NoteInstanceType;
